module.exports = __webpack_public_path__ + "img/18_74.9b1ac582.png";